// Island Zone System - World configuration for TypeTown

export const ISLAND_SIZE = 16000;
export const ZONE_SIZE = 8000;

export const ZONES = {
  CENTER: { id: 0, name: 'Central Meadow', stage: 1, color: '#90EE90' },
  NORTH: { id: 1, name: 'Snowy North', stage: 2, color: '#E8F4F8' },
  EAST: { id: 2, name: 'Eastern Hills', stage: 3, color: '#C8E6C9' },
  SOUTH: { id: 3, name: 'Southern Beach', stage: 4, color: '#FFE4B5' },
  WEST: { id: 4, name: 'Western Mountains', stage: 5, color: '#FFB6C1' },
};

// Get which zone a position is in
export const getZone = (x, y) => {
  if (x > ZONE_SIZE && y < -ZONE_SIZE) return ZONES.NORTH;
  if (x > ZONE_SIZE && y > ZONE_SIZE) return ZONES.EAST;
  if (x < -ZONE_SIZE && y > ZONE_SIZE) return ZONES.SOUTH;
  if (x < -ZONE_SIZE && y < -ZONE_SIZE) return ZONES.WEST;
  if (y < -ZONE_SIZE) return ZONES.NORTH;
  if (x > ZONE_SIZE) return ZONES.EAST;
  if (y > ZONE_SIZE) return ZONES.SOUTH;
  if (x < -ZONE_SIZE) return ZONES.WEST;
  return ZONES.CENTER;
};

// Check if a zone is unlocked based on player's stage
export const isZoneUnlocked = (zone, playerStage) => {
  return playerStage >= zone.stage;
};

// Zone ground colors for distinct biome appearance
export const ZONE_COLORS = {
  CENTER: { primary: '#90EE90', secondary: '#7CCD7C', accent: '#98FB98' },
  NORTH: { primary: '#E8F4F8', secondary: '#B0C4DE', accent: '#F0F8FF' },
  EAST: { primary: '#C8E6C9', secondary: '#A5D6A7', accent: '#E8F5E9' },
  SOUTH: { primary: '#FFE4B5', secondary: '#F5DEB3', accent: '#FFEFD5' },
  WEST: { primary: '#FFB6C1', secondary: '#DDA0DD', accent: '#FFC0CB' },
};

// Stage Icons Configuration
export const STAGE_ICONS = {
  1: { icon: "🏕️", name: "Newcomer", color: "#FF6B6B" },
  2: { icon: "🗺️", name: "Explorer", color: "#FFD93D" },
  3: { icon: "🏗️", name: "Builder", color: "#6BCB77" },
  4: { icon: "⭐", name: "Master", color: "#4ECDC4" },
  5: { icon: "🏆", name: "Champion", color: "#A66CFF" },
  6: { icon: "🌆", name: "Legend", color: "#FF69B4" },
};
